import {createContext} from 'react';
import {DEFAULT_THEME} from '../util/theme';

/**
 * Cross-cutting state for the custom node components. Kept in context (not
 * node.data) so it does NOT churn node data on every drag frame (§B2.9):
 * these values change only on discrete events (view toggle, edit/view, theme).
 * `actions` are stable dispatch-bound callbacks provided by LineageEditor.
 */
export const LineageContext = createContext({
  lineageViewType: 'system',
  viewMode: 'edit',
  theme: DEFAULT_THEME,
  characteristics: [],
  actions: {
    selectElement: () => {},
    addElement: () => {},
    updateElement: () => {},
    removeElement: () => {},
    openNodeDrawer: () => {},
  },
});
